module.exports = __webpack_public_path__ + "img/jzfw.9f688df.png";